<ifc-app-scroll-container [widgetsWithTopHeader]="true">
  <div class="layout margin flex-std"
       [@routerTransition]="'fly'">
    <ifb-panel>
      <ifb-card>
        <ifc-simple-horizontal-list-widget title="Status"
                                           [listItems]="statusListData">
        </ifc-simple-horizontal-list-widget>
      </ifb-card>
      <ifb-card>
        <ifc-simple-horizontal-list-widget title="Application"
                                           [listItems]="applicationListData">
        </ifc-simple-horizontal-list-widget>
      </ifb-card>
    </ifb-panel>
  </div>
</ifc-app-scroll-container>
